import utilPublic from "@/util/public";

export default {
  getDatePeriodList (dateStart = new Date(), day = 0) {
    let dateList = []
    let periodList = []
    let businessWeekDay = ["週日", "週一", "週二", "週三", "週四", "週五", "週六"]

    for (let i = 0; i <= day; i++) {
      let date = new Date(dateStart)

      date.setDate(date.getDate() + i)
      let weekDay = date.getDay()

      dateList.push({
        dataIndex: i,
        date: utilPublic.dateFormat('yyyy-MM-dd', date),
        dateText: utilPublic.dateFormat('M月dd日', date) + " " + businessWeekDay[weekDay],
      })
    }

    let index = 0
    for (let i = 0; i < 24; i++) {
      let hour = i > 9 ? i.toString() : "0" + i
      let nextHour = i + 1 > 9 ? (i + 1).toString() : "0" + (i + 1)
      nextHour = nextHour === "24" ? "00" : nextHour

      periodList.push({
        dataIndex:  index,
        period:     hour + ":00:00",
        periodText: hour + ":00至" + hour + ":15"
      })
      index++

      periodList.push({
        dataIndex:  index,
        period:     hour + ":15:00",
        periodText: hour + ":15至" + hour + ":30"
      })
      index++

      periodList.push({
        dataIndex:  index,
        period:     hour + ":30:00",
        periodText: hour + ":30至" + hour + ":45"
      })
      index++

      periodList.push({
        dataIndex:  index,
        period:     hour + ":45:00",
        periodText: hour + ":45至" + nextHour + ":00"
      })
      index++
    }

    return {
      dateList:   dateList,
      periodList: periodList,
    }
  },

    /** 轉換日期格式 */
    transDate (dateStart = new Date(), dateFormat = 'yyyy-MM-dd') {
        let businessWeekDay = ["日", "一", "二", "三", "四", "五", "六"]
        let date = new Date(dateStart)
        let weekDay = date.getDay()

        return {
          dateString: utilPublic.dateFormat(dateFormat, date),
          weekDay: businessWeekDay[weekDay],
        };
    },
}
Date.prototype.isToday = function() {
    if (this === undefined || this === null)
        return false;

    const today = new Date();

    return this.getDate() === today.getDate() &&
        this.getMonth() === today.getMonth() &&
        this.getFullYear() === today.getFullYear();
}
